// extracted by mini-css-extract-plugin
module.exports = {"link":"_eb1f3716","arrow":"_4262848f"};